import isSwipeDetected from './is-swipe-detected';
import isSwipeDirectionLeft from './is-swipe-direction-left';

export default {
  isSwipeDetected,
  isSwipeDirectionLeft,
};
